/**
 * Cognito group for Manufacturers Management.
 * Keep in sync with services/ms-casino userFlagHelper
 * MANUFACTURERS_MANAGEMENT_GROUP / canAccessManufacturersManagement.
 */
export const MANUFACTURERS_MANAGEMENT_GROUP =
  'slotcheck-enterprise-manufacturersManagement';

/** True when cognito:groups includes the Manufacturers Management enterprise group. */
export function canAccessManufacturersManagement(groups: string[] = []): boolean {
  return Array.isArray(groups) && groups.includes(MANUFACTURERS_MANAGEMENT_GROUP);
}

/** Side menu item is shown only to manufacturers-management group members. */
export function shouldShowManufacturersManagementMenu(groups: string[] = []): boolean {
  return canAccessManufacturersManagement(groups);
}
